import { api } from './api';

const BASE = 'moms';

export const listMoms = () => api.get(`${BASE}/`).then(r => r.data);
export const addMom = (payload) => api.post(`${BASE}/`, payload).then(r => r.data);
export const getMom = (id) => api.get(`${BASE}/${id}`).then(r => r.data);
export const updateMom = (id, payload) => api.put(`${BASE}/${id}`, payload).then(r => r.data);

// Convenience / additional endpoints
export const getMyLatestMom = () => api.get(`${BASE}/latest/my`).then(r => r.data);
export const confirmMom = (payload) => api.post(`${BASE}/confirm`, payload).then(r => r.data);
export const addMomPoints = (id, payload) => api.post(`${BASE}/${id}/points`, payload).then(r => r.data);

// Lookup helper (client-side convenience)
export const listLookupsByName = (name) => api.get(`lookups/by-name/${encodeURIComponent(name)}`).then(r => r.data);

export default {
  listMoms,
  addMom,
  getMom,
  updateMom,
  getMyLatestMom,
  confirmMom,
  addMomPoints,
  listLookupsByName,
};

// import axios from 'axios';

// export async function listMoms(params = {}) {
//   const res = await axios.get('/api/moms/', { params });
//   return res.data;
// }

// export async function addMom(payload) {
//   const res = await axios.post('/api/moms/', payload);
//   return res.data;
// }

// export async function getMom(id) {
//   const res = await axios.get(`/api/moms/${id}`);
//   return res.data;
// }

// export async function updateMom(id, payload) {
//   const res = await axios.put(`/api/moms/${id}`, payload);
//   return res.data;
// }

// export async function listLookupsByName(name) {
//   const res = await axios.get(`/api/lookups/by-name/${encodeURIComponent(name)}`);
//   return res.data;
// }